import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function useCounter(target, active, duration = 1800) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf, start;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      setVal(Math.floor(p * target));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, target, duration]);
  return val;
}

function StatCard({ label, value, suffix, prefix, i }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const v = useCounter(value, inView);
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: i * 0.08 }}
      className="relative p-8 md:p-10 border-r border-white/5 last:border-r-0"
      data-testid={`stat-${label.toLowerCase()}`}
    >
      <div className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-none">
        <span className="neon-blue">{prefix}{v.toLocaleString("pt-BR")}{suffix}</span>
      </div>
      <div className="mt-3 overline text-neutral-400">{label}</div>
    </motion.div>
  );
}

export default function Stats({ settings }) {
  const stats = [
    { label: "Eventos", value: settings?.stats_events ?? 100, prefix: "+", suffix: "" },
    { label: "Simuladores", value: settings?.stats_simulators ?? 20, prefix: "+", suffix: "" },
    { label: "Pessoas impactadas", value: settings?.stats_people ?? 10000, prefix: "+", suffix: "" },
    { label: "Diversão", value: settings?.stats_fun ?? 100, prefix: "", suffix: "%" },
  ];
  return (
    <section className="relative py-16 md:py-24 bg-black border-y border-white/5" data-testid="stats-section">
      <div className="race-line absolute top-0 inset-x-0" />
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <StatCard key={s.label} i={i} {...s} />
          ))}
        </div>
      </div>
      <div className="race-line absolute bottom-0 inset-x-0" />
    </section>
  );
}
